export default function R_Intro() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Intro Component</h1>
      <p>This is the R_Intro tutorial section.</p>
    </div>
  );
}
